import { ValueOf } from '@approvalmax/types';
import { domain } from 'modules/data';

export const useIsBudgetingAvailable = ({
    integrationType,
    licenseFeatures,
    betaFeatures,
}: {
    integrationType?: ValueOf<domain.IntegrationType>;
    licenseFeatures: domain.CompanyLicenseFeature[];
    betaFeatures: domain.CompanyBetaFeature[];
}) => {
    const isXeroIntegration = integrationType === domain.IntegrationType.Xero;
    const isQBooksIntegration = integrationType === domain.IntegrationType.QBooks;

    const hasXeroBudgetsFeature = licenseFeatures.includes(domain.CompanyLicenseFeature.XeroBudgets);
    const hasQBooksBudgetsFeature =
        betaFeatures.includes(domain.CompanyBetaFeature.QBooksBudgeting) ||
        licenseFeatures.includes(domain.CompanyLicenseFeature.QBOBudgets);

    const isXeroBudgetingAvailable = isXeroIntegration && hasXeroBudgetsFeature;
    const isQBooksBudgetingAvailable = isQBooksIntegration && hasQBooksBudgetsFeature;

    return isXeroBudgetingAvailable || isQBooksBudgetingAvailable;
};
